import React from "react";
import { ExternalLink, Sparkles, Globe, ArrowUpRight } from "lucide-react";
import "./LiveProducts.css";

const liveProductsData = [
  {
    id: "nirnaya",
    title: "Nirnaya",
    category: "AI Meeting Intelligence",
    tagline: "Intelligent meeting transcription, automated synthesis & action item extraction.",
    description:
      "Enterprise AI meeting intelligence system providing automated speech recognition, transcript summarization, action item detection, and analytics dashboards for business meetings.",
    logo: "/logos/nirnaya.png",
    url: "https://ai-meeting-intelligence-five.vercel.app/login?utm_source=chatgpt.com",
    tags: ["Node.js", "Python AI", "React", "PostgreSQL", "JWT Auth", "Vercel"],
    badge: "Live AI Product",
    accent: "#C34A26",
  },
  {
    id: "muvonark",
    title: "Muvonark",
    category: "Startup & Technology Platform",
    tagline: "Modern technology and digital incubation platform for fast-growing startups.",
    description:
      "Full-scale technology platform designed to streamline startup workflows, showcase emerging products, and deliver scalable web infrastructure with high uptime and responsive performance.",
    logo: "/logos/muvonark.png",
    url: "https://www.muvonark.com/",
    tags: ["React.js", "TypeScript", "Node.js", "REST APIs", "Modern Cloud"],
    badge: "Live Platform",
    accent: "#1C1815",
  },
  {
    id: "graduate-chai",
    title: "Graduate Chai & Lassi",
    category: "Business Software & Operations",
    tagline: "Commercial franchise software, billing, inventory & operations platform.",
    description:
      "Production enterprise business management system powering multi-location franchise operations, automated billing, inventory control, and real-time operational accounting.",
    logo: "/logos/graduatechai.png",
    url: "https://graduatechai.in/",
    tags: ["Node.js", "PostgreSQL", "ERP/Billing Engine", "Business Operations"],
    badge: "Live Enterprise",
    accent: "#8B261D",
  },
];

const LiveProducts = () => {
  return (
    <section id="live-products" className="section section-secondary live-products-section">
      <div className="container">
        
        {/* SECTION HEADER */}
        <div className="section-header">
          <div className="eyebrow">02 / Verified Deployments</div>
          <h2 className="section-title">
            Live Commercial <em>Products</em>
          </h2>
          <p className="section-subtitle">
            Production applications and live platforms built for commercial operations, real users, and high-reliability environments.
          </p>
        </div>

        {/* PRODUCTS SHOWCASE GRID */}
        <div className="live-products-grid">
          {liveProductsData.map((product) => (
            <div
              key={product.id}
              className="live-product-card"
              onClick={() => window.open(product.url, "_blank", "noopener,noreferrer")}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") window.open(product.url, "_blank", "noopener,noreferrer");
              }}
            >
              
              {/* TOP HEADER */}
              <div className="product-top-bar">
                <span className="badge badge-live">
                  <span className="live-dot"></span>
                  {product.badge}
                </span>

                <a
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="product-external-link"
                  onClick={(e) => e.stopPropagation()}
                  title={`Open ${product.title} live website`}
                >
                  <Globe size={14} />
                  <span>Visit Live</span>
                  <ArrowUpRight size={14} />
                </a>
              </div>

              {/* LOGO & HERO ROW */}
              <div className="product-identity-row">
                <div className="product-logo-box">
                  <img
                    src={product.logo}
                    alt={`${product.title} Logo`}
                    className="product-logo-img"
                  />
                </div>
                <div className="product-identity-text">
                  <h3 className="product-name">
                    <a
                      href={product.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {product.title}
                    </a>
                  </h3>
                  <span className="product-category">{product.category}</span>
                </div>
              </div>

              {/* DESCRIPTION & TAGLINE */}
              <p className="product-tagline">{product.tagline}</p>
              <p className="product-desc">{product.description}</p>

              {/* TECH STACK CHIPS */}
              <div className="product-tags">
                {product.tags.map((t, idx) => (
                  <span key={idx} className="tech-chip">{t}</span>
                ))}
              </div>

              {/* CARD FOOTER */}
              <div className="product-footer">
                <div className="product-url-preview">
                  <span className="url-protocol">https://</span>
                  <span className="url-domain">{product.url.replace("https://", "").split("?")[0]}</span>
                </div>
                <div className="view-action-indicator">
                  <span>Explore Product</span>
                  <ExternalLink size={14} />
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LiveProducts;
